import React from 'react';
import styles from '../../styles/unauthorizedPage.module.css';
import logoFr from "../../images/appGoFr.png";
import logoEn from "../../images/appGoEn.png";
import { GetLanguage } from '../../utils/language';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import Button from '@material-ui/core/Button';

class UnauthorizedPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            logo: logoFr
        };
    }

    componentDidMount() {
        if (GetLanguage() == 'fr') {
            this.setState({ logo: logoFr });
        } else {
            this.setState({ logo: logoEn });
        }
    }

    handleButtonClick = () => {
        window.location.href = '';
    }

    render() {
        return <div className={styles.rootUnauthorizedPage}>
            <div className={styles.unauthorizedMessage}>
                <p style={{ textAlign: "left", marginBottom: "unset" }}>
                    <span className={styles.headerSpan}>{i18next.t('unauthorizedPage:content.title')}</span>
                </p>
                <p className={styles.contentWrapper}>
                    <span className={styles.contentSpan}>{i18next.t('unauthorizedPage:content.subtitle')}</span>
                </p>
            </div>
            <div>
                <Button
                    className={styles.punchButton}
                    variant="contained"
                    color="primary"
                    onClick={this.handleButtonClick}
                >
                    {i18next.t('unauthorizedPage:button.home')}
                </Button>
            </div>
        </div>;
    }
}
export default withNamespaces(['unauthorizedPage'], { wait: true })(UnauthorizedPage);